import styled from 'styled-components';

export const StyledAvatar = styled.div`
  width: ${({ theme }) => theme.avatarSize};
  height: ${({ theme }) => theme.avatarSize};
  cursor: pointer;
  position: relative;

  .avatar-border {
    padding: ${({ theme }) => theme.buttonFrameWidth};
    background: ${({ theme, $selected, $hovered}) => $selected ? theme.selection : $hovered ? 'white' : 'transparent'};
    clip-path: polygon(25% 0, 100% 0, 100% 100%, 0 100%, 0% 25%);
    width: 100%;
    height: 100%;
  }

  .avatar-internal-border {
    padding: ${({ theme, $hovered, $selected }) => $hovered || $selected ? theme.buttonFrameWidth : 0};
    background: ${({ theme }) => theme.borderDark};
    clip-path: polygon(25% 0, 100% 0, 100% 100%, 0 100%, 0% 25%);
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    clip-path: polygon(25% 0, 100% 0, 100% 100%, 0 100%, 0% 25%);
    transition: scale linear 0.2s, clip-path linear 0.2s;

    &:hover {
      scale: 1.2;
      clip-path: polygon(37% 0, 100% 0, 100% 100%, 0 100%, 0% 37%);
    }
  }

  .avatar-decorator {
    width: 20%;
    height: 20%;
    background: ${({ theme }) => theme.borderDark};
    clip-path: polygon(100% 0, 0 0, 0 100%);
    position: absolute;
    top: ${({ theme }) => theme.buttonFrameWidth};
    left: ${({ theme }) => theme.buttonFrameWidth};
    padding: 2px;

    div {
      clip-path: polygon(100% 0, 0 0, 0 100%);
      width: 80%;
      height: 80%;
      background: ${({ theme, $hovered, $selected }) => $selected ? theme.selectionGreen : $hovered ? theme.selectionBlue : theme.background};
    }
  }
`;
